import CustomSelect from "components/customs/dropdown";
import SearchBarComponent from "components/customs/searchbarV2";
import React from "react";
import { canEditRoles } from "utility/constants";
import { Trash2 } from "react-feather";
import styled from "styled-components";
import { batchStatusStyle, dropdownSelectStyle } from "constants/style";
import { Button } from "reactstrap";
import { getStatusOptions } from "views/representatives/congressman/utility";
import { getAllocationTypeOptions } from "views/projects/add/utility";
import { ALLOCATION_STATUS_FILTER } from "constants/status";
import { resendOptions } from "../../constants";

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  align-items: center;
  margin-top: 16px;
`;

const StyledSelect = styled(CustomSelect)`
  width: 20%;

  .select__control {
    background-color: ${({ theme }) => theme.colors.buttonBlue};
    height: clamp(35px, 5vw, 50px);
    border-radius: 9px;
  }
`;

const SearchbarWrapper = styled.div`
  width: 20%;
  position: relative;

  input {
    border: 2px solid ${({ theme }) => theme.colors.black60};
    background: white;
    box-shadow: none;
    border-radius: 9px;
    height: clamp(35px, 5vw, 50px);
  }
`;

const StyledTrashIcon = styled(Trash2)`
  margin-right: 0.25rem;
`;

const StyledBulkDeleteBtn = styled(Button)`
  width: 20%;
  border-radius: 9px;
  background-color: #df3348 !important;
  height: clamp(35px, 5vw, 50px);
  display: flex !important;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: none;
`;

const ProgramFilters = ({
  selectedStatusFilter,
  setSelectedStatusFilter,
  selectedAllocationType,
  setSelectedAllocationType,
  onChangeSearch,
  tableOption,
  role,
  checkedItems,
  handleBatchUpdate,
  setMessageType,
  handleShowResendModal,
  handleMultipleDelete,
  selectedStatus,
}) => {
  const isExecutive = canEditRoles.includes(role);

  return (
    <Wrapper>
      {isExecutive && (
        <CustomSelect
          placeholder="Status"
          name="statusFilter"
          styles={dropdownSelectStyle}
          onChange={(option) => {
            setSelectedStatusFilter(option);
          }}
          value={selectedStatusFilter}
          options={ALLOCATION_STATUS_FILTER}
          isMulti
          isSearchable={false}
          hideSelectedOptions={false}
        />
      )}

      <CustomSelect
        isSearchable={false}
        onChange={(option) => {
          setSelectedAllocationType(option);
        }}
        placeholder="TYPE"
        options={getAllocationTypeOptions({ role, filterMode: true })}
        value={selectedAllocationType}
        styles={dropdownSelectStyle}
        getOptionLabel={(option) => {
          return option?.label;
        }}
        isClearable
        isMulti
      />

      <SearchbarWrapper>
        <SearchBarComponent
          onChangeSearch={onChangeSearch}
          isDisabled={tableOption?.isLoading}
        />
      </SearchbarWrapper>

      {checkedItems.length !== 0 && (
        <>
          <StyledSelect
            isSearchable={false}
            onChange={(option) => {
              handleBatchUpdate(option);
            }}
            placeholder="Change Status"
            options={getStatusOptions(selectedStatus, role)}
            styles={batchStatusStyle}
            getOptionLabel={(option) => {
              return option?.displayLabel;
            }}
          />

          <StyledSelect
            isSearchable={false}
            onChange={(option) => {
              setMessageType(option.value);
              handleShowResendModal();
            }}
            placeholder="Resend"
            options={resendOptions}
            styles={batchStatusStyle}
          />

          <StyledBulkDeleteBtn
            onClick={() => {
              handleMultipleDelete();
            }}
          >
            <StyledTrashIcon />
            {"Delete Selected"}
          </StyledBulkDeleteBtn>
        </>
      )}
    </Wrapper>
  );
};

export default ProgramFilters;
